export default __webpack_public_path__ + "static/media/correct-swish.36751367.wav";